export default function normalizeCiList(ciList) {
    if (Array.isArray(ciList)) {
        return ciList.map(item => String(item).trim()).filter(Boolean)
    }

    if (typeof ciList === 'string') {
        return ciList
            .split(',')
            .map(item => item.trim())
            .filter(Boolean)
    }

    return []
}
